"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _TextArea = _interopRequireDefault(require("./TextArea"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "textarea": "DefaultTheme__textarea___1pfrP",
  "has-error": "DefaultTheme__has-error___1i6LW",
  "is-dirty": "DefaultTheme__is-dirty___3tN6n",
  "hasError": "DefaultTheme__has-error___1i6LW",
  "isDirty": "DefaultTheme__is-dirty___3tN6n"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "textarea": "DarkTheme__textarea___bz0af",
  "is-focused": "DarkTheme__is-focused___1TP1y",
  "isFocused": "DarkTheme__is-focused___1TP1y"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "textarea": "LumeTheme__textarea___UqEG5"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('TextArea', themes.DefaultTheme)(_TextArea["default"]);
ThemedComponent.displayName = 'TextArea';
ThemedComponent.themes = themes;
ThemedComponent.isFormComponent = true;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map